<template>
  <div class="content">
    <div class="hospital hp_space_between">
      <div class="hp_flex">
        <div class="hospitalImg hp_center">
          <img
            v-if="dept.image"
            :src="base_url+dept.image"
            alt
          />
          <img
            v-else
            src="@/assets/default-img/hospital.png"
            alt
          />
        </div>

        <div class="detail">
          <div
            class="tags hp_cz_center"
            style="margin-bottom: 0px;"
          >
            <span class="name">{{ dept.name }}</span>
            <div
              v-if="dept.important"
              class="tag"
            >{{ getImportantName(dept.important) }}</div>
          </div>
          <div class="tags hp_cz_center">
            <span class="hopital">{{ dept.hospitalName }}</span>
            <span
              v-if="dept.levelName"
              class="tag"
            >{{ dept.levelName }}</span>
            <span
              v-if="dept.adminLevelName"
              class="tag"
            >
              {{
              dept.adminLevelName
              }}
            </span>
            <template v-if="dept.typeNames">
              <div
                v-for="(tag, index) in dept.typeNames.split(',')"
                :key="index"
                class="tag"
              >{{ tag }}</div>
            </template>
          </div>
          <div class="mobile hp_cz_center">
            <icon-font
              style="font-size:14px;"
              type="icon-dianhua01"
            />
            <span>{{ dept.tel }}</span>
          </div>
          <p class="mobile hp_cz_center">
            <icon-font
              style="font-size:14px;"
              type="icon-dingwei2"
            />
            <span>{{ dept.address }}</span>
          </p>
          <template>
            <div class="synopsis">
              <p>简介：{{dept.intro||'暂无简介'}}</p>
              <span @click="toment()">更多</span>
            </div>
          </template>
        </div>
        <div
          class="attention hp_center"
          @click="attention"
        >
          <icon-font
            :class="{ active: dept.favorite }"
            type="icon-guanzhu1"
          />
          <span class="text-center-g">{{ dept.favorite ? '已关注' : '关注' }}</span>
        </div>
      </div>
    </div>
    <div class="depts">
      <div class="hp_flex days">
        <div
          :class="{ active: item.active }"
          class="hp_center day"
          v-for="(item, index) in timeDaysList"
          :key="index"
          @click="changeDay(index)"
        >
          {{ item.text }}
          <br />
          {{ item.dayTime }}
        </div>
      </div>
      <div>
        <a-skeleton :loading="loading1" />
        <template v-if="!loading1">
          <div
            v-if="doctorDay&&doctorDay.length>0"
            class="doctors"
          >
            <div
              v-for="(item, index) in doctorDay"
              :key="index"
              class="doctor hp_cz_center_s"
            >
              <div class="hp_cz_center doctor_left">
                <img
                  class="photo"
                  v-if="item.avatar"
                  :src="base_url + item.avatar"
                  alt
                />
                <img
                  class="photo"
                  v-else
                  src="@/assets/default-img/r-doctor.png"
                  alt
                />
                <div>
                  <div class="name">{{ item.name }}</div>
                  <div class="money">余号：{{ item.availableCount }} 挂号费：￥{{ item.unitPrice }}</div>
                  <a-rate
                    disabled
                    style="color:#FF9C00;"
                    :default-value="item.score"
                    allow-half
                  />
                </div>
              </div>
              <div
                class="btn"
                @click="toPage('/registered/doctor/' + item.id+'/'+active)"
              >挂号</div>
            </div>
          </div>
          <noData v-else></noData>
        </template>
      </div>
    </div>
    <div class="dept_doctors">
      <div class="title">科室医生</div>
      <a-skeleton :loading="loading2" />
      <template v-if="!loading2">
        <div
          v-if="doctorAll&&doctorAll.length>0"
          class="doctors"
        >
          <div
            v-for="(item, index) in doctorAll"
            :key="index"
            class="doctor hp_cz_center_s"
          >
            <div class="hp_cz_center doctor_left">
              <img
                class="photo"
                v-if="item.avatar"
                :src="base_url + item.avatar"
                alt
              />
              <img
                class="photo"
                v-else
                src="@/assets/default-img/r-doctor.png"
                alt
              />
              <div>
                <div class="name">{{ item.name }}</div>
                <div class="money">余号：{{ item.availableCount }} 挂号费：￥{{ item.unitPrice }}</div>
                <a-rate
                  disabled
                  style="color:#FF9C00;"
                  :default-value="item.score"
                  allow-half
                />
              </div>
            </div>
            <div
              class="btn"
              @click="toPage('/registered/doctor/' + item.id+'/'+active)"
            >挂号</div>
          </div>
        </div>
        <noData v-else></noData>
      </template>
    </div>
  </div>
</template>
<script>
import {
  getDeptDetail,
  getScheduleDoctor,
  getReserveDoctor,
  cancelFavorite,
  submitFavorite,
} from "@/api/registered";
import { ls } from "@/utils/tool";
import noData from "@/components/NoData";
export default {
  components: {
    noData,
  },
  data() {
    return {
      deptId: this.$route.params.id,
      dept: {},
      timeDaysList: [],
      day: "",
      doctorDay: [],
      doctorAll: [],
      loading1: true,
      loading2: true,
      active: 0,
    };
  },
  created() {
    this.initDept();
    this.initTime();
    this.getReserveDoctor();
    this.$store.commit("showLoading");
  },
  mounted() {},
  methods: {
    toPage(url) {
      this.$router.push(url);
    },
    async getReserveDoctor() {
      this.loading2 = true;
      var res = await getReserveDoctor({
        deptId: this.deptId,
        scoreFlag: true,
      });
      console.log("res=====", res);
      this.doctorAll = res.data;
      this.loading2 = false;
    },
    async initDept() {
      this.$store.commit("showLoading");
      var res = await getDeptDetail(this.deptId);
      this.dept = res.data;
      this.$store.commit("hideLoading");
    },
    initTime() {
      var arr = [];
      var weekArr = ["日", "一", "二", "三", "四", "五", "六"];
      for (let index = 0; index < 7; index++) {
        arr.push({
          text: index
            ? "周" + weekArr[this.dayjs().add(index, "day").day()]
            : "今天",
          dayTime: index ? this.dayjs().add(index, "day").format("MM/DD") : "",
          day: index
            ? this.dayjs().add(index, "day").format("YYYY-MM-DD")
            : this.dayjs().format("YYYY-MM-DD"),
          active: false,
        });
      }
      arr[0].active = true;
      this.timeDaysList = arr;
      this.day = arr[0].day;
      this.getScheduleDoctor(this.day);
    },
    changeDay(index) {
      this.timeDaysList = this.timeDaysList.map((item) => {
        item.active = false;
        return item;
      });
      this.timeDaysList[index].active = true;
      this.getScheduleDoctor(this.timeDaysList[index].day);
      console.log(index);
      this.active = index;
    },

    async getScheduleDoctor(day) {
      this.loading1 = true;
      var params = {
        day,
        deptId: this.deptId,
      };
      var res = await getScheduleDoctor(params);
      this.doctorDay = res.data;
      this.loading1 = false;
    },
    async attention() {
      let sysUser = ls.get("sysUser");
      if (!sysUser) {
        this.$message.warning("请登录后再收藏!");
        this.$router.push("/login");
        return;
      }
      if (this.dept.favorite) {
        let res = await cancelFavorite({
          memberId: sysUser.id,
          objectId: this.dept.id,
          objectType: 2,
        });
        this.initDept();
      } else {
        let res = await submitFavorite({
          memberId: sysUser.id,
          objectId: this.dept.id,
          objectType: 2,
        });
        this.initDept();
      }
    },
    // 查看科室详情
    toment() {
      console.log(this.dept.id);
      this.$router.push("/registered/department/" + this.dept.id);
    },
  },
};
</script>
<style lang="less" scoped>
.content {
  width: 911px;
  box-shadow: 0px 0px 21px 0px rgba(154, 200, 255, 0.32);
  border-radius: 10px;
  padding: 25px 21px;
  .hospital {
    padding-bottom: 30px;
    border-bottom: solid 5px #f6f6f6;
    position: relative;
    .hospitalImg {
      width: 339px;
      height: 220px;
      margin-right: 26px;
      border-radius: 6px;
      overflow: hidden;
      img {
        height: 100%;
      }
    }
    .detail {
      width: calc(100% - 420px);
      .tags {
        width: 100%;
        flex-wrap: wrap;
        margin-top: 6px;
        margin-bottom: 15px;
        .name {
          font-size: 28px;
          font-family: Source Han Sans CN;
          font-weight: bold;
          color: #333333;
          margin-right: 10px;
        }
        .hopital {
          font-size: 20px;
          font-weight: 400;
          color: #333333;
          margin-right: 18px;
          margin-bottom: 12px;
        }
        .tag {
          border-radius: 10px;
          padding: 7px 12px;
          line-height: 1;
          font-size: 14px;
          color: #ffffff;
          background: #0079fe;
        }
        .tag:not(:last-child) {
          margin-right: 19px;
        }
      }
      .mobile {
        width: 100%;
        margin-top: 12px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #666666;
        span {
          margin-left: 15px;
        }
      }
      .synopsis {
        position: relative;
        font-size: 14px;
        p {
          width: 400px;
          margin: 0;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        span {
          color: blue;
          position: absolute;
          top: 0;
          right: -20px;
          cursor: pointer;
        }
      }
    }
    .attention {
      cursor: pointer;
      line-height: 1;
      border: 1px solid #dcdcdc;
      border-radius: 8px;
      padding: 8px 6px;
      height: 34px;
      /deep/ .anticon {
        margin-right: 6px;
        font-size: 16px;
        color: #999;
      }
      .active {
        color: #d81e06;
      }
      span {
        display: inline-block;
        white-space: nowrap;
      }
    }
  }
  .depts {
    padding-bottom: 30px;
    border-bottom: solid 5px #f6f6f6;
    .days {
      margin-top: 10px;
      margin-bottom: 32px;
      border: 1px solid #dcdcdc;
      width: 707px;
      .day {
        cursor: pointer;
        font-size: 16px;
        color: #666666;
        line-height: 1;
        width: 102px;
        height: 48px;
        text-align: center;
      }
      .day:not(:last-child) {
        border-right: 1px solid #dcdcdc;
      }
      .active {
        background: #4694ff;
        color: #fff;
      }
    }
  }
  .dept_doctors {
    .title {
      font-size: 26px;
      font-weight: bold;
      color: #333333;
      padding: 25px 0;
    }
  }
  .doctors {
    display: flex;
    flex-wrap: wrap;
    .doctor {
      width: calc(50% - 42px);
      margin-bottom: 12px;
      .doctor_left {
        width: calc(100% - 86px);

        .photo {
          border: 1px solid #0079fe;
          width: 62px;
          height: 62px;
          border-radius: 50%;
          margin-right: 20px;
          overflow: hidden;
        }
        .name {
          font-size: 18px;
          font-weight: 400;
          color: #333333;
        }
        .money {
          font-size: 16px;
          font-weight: 400;
          color: #666666;
        }
      }

      .btn {
        cursor: pointer;
        width: 86px;
        height: 40px;
        background: #0079fe;
        border-radius: 6px;
        font-size: 18px;
        font-weight: 400;
        color: #ffffff;
        line-height: 40px;
        text-align: center;
      }
    }
    .doctor:nth-child(2n) {
      margin-left: 84px;
    }
  }
}
</style>
